// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchForm_search-form__7J1Fv {
  position: absolute;
  right: 15px;
  top: 15px;
  width: calc(100% - 30px);
  z-index: 150000;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  max-height: calc(100vh - 80px);
  max-height: calc(100 * var(--vh) - 80px);
  box-shadow: var(--shadow);
  border-radius: 22px;
  background-color: white;
}
.SearchForm_search-form__7J1Fv > * {
  margin: 2px;
  width: 100%;
}
.SearchForm_search-form__7J1Fv input {
  padding: 10px 22px;
  font-size: 16px;
  border-radius: 22px;
  border: none;
  transition: border-radius 0.3s ease;
  margin: 0;
  width: 100%;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-icon__aSlWY {
  display: none;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-icon__aSlWY svg {
  fill: #222;
  height: 18px;
  width: 18px;
}
@media screen and (max-width: 600px) {
  .SearchForm_search-form__7J1Fv {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 23px;
    max-width: 500px;
  }
  .SearchForm_search-form__7J1Fv .SearchForm_search-icon__aSlWY {
    display: flex;
  }
  .SearchForm_search-form__7J1Fv input {
    display: none;
  }
  .SearchForm_search-form__7J1Fv:hover, .SearchForm_search-form__7J1Fv:active {
    width: calc(100% - 30px);
    border-radius: 22px;
    height: -moz-fit-content;
    height: fit-content;
    right: 15px;
  }
  .SearchForm_search-form__7J1Fv:hover input, .SearchForm_search-form__7J1Fv:active input {
    display: block;
  }
  .SearchForm_search-form__7J1Fv:hover .SearchForm_search-icon__aSlWY, .SearchForm_search-form__7J1Fv:active .SearchForm_search-icon__aSlWY {
    display: none;
  }
}
.SearchForm_search-form__7J1Fv .SearchForm_custom-select__VUgY9 {
  font-weight: 500;
  padding: 10px 20px;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz {
  padding: 10px 0;
  overflow-y: scroll;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_no-results-found__zTQMb {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: grey;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a {
  padding: 5px 20px;
  display: block;
  text-decoration: none;
  color: rgb(50, 50, 50);
  font-weight: 500;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a .SearchForm_main__2BFub {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a .SearchForm_main__2BFub .SearchForm_distance__eC9mC {
  font-size: small;
  color: grey;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a .SearchForm_sub__z5FKm {
  margin-top: 0;
  color: grey;
  font-size: small;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a:first-child {
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a:last-child {
  border-bottom-left-radius: 22px;
  border-bottom-right-radius: 22px;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a .SearchForm_skills__CBysm {
  margin-top: 0;
  color: grey;
  font-size: small;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA a .SearchForm_objects__TTKar {
  margin-top: 0;
  color: grey;
  font-size: small;
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_result__qX\\+oA:hover {
  background-color: rgb(216, 255, 205);
}
.SearchForm_search-form__7J1Fv .SearchForm_search-results__68gYz .SearchForm_loading-spinner__Src91 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.SearchForm_search-form__7J1Fv .SearchForm_close-or-open-results-list__cdhvm {
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
.SearchForm_search-form__7J1Fv .SearchForm_close-or-open-results-list__cdhvm:hover {
  background-color: #eee;
}

.SearchForm_search-form__7J1Fv.SearchForm_searching__ZvHu9 {
  padding: 10px 20px 2px 20px;
  background-color: white;
  border-radius: 30px;
  max-width: 500px;
}
.SearchForm_search-form__7J1Fv.SearchForm_searching__ZvHu9 input {
  border-radius: 0;
  border-bottom: 1px solid rgb(200, 200, 200);
}
@media screen and (max-width: 600px) {
  .SearchForm_search-form__7J1Fv.SearchForm_searching__ZvHu9 {
    width: calc(100% - 30px);
    border-radius: 22px;
    height: -moz-fit-content;
    height: fit-content;
    right: 15px;
  }
  .SearchForm_search-form__7J1Fv.SearchForm_searching__ZvHu9 .SearchForm_search-icon__aSlWY {
    display: none;
  }
  .SearchForm_search-form__7J1Fv.SearchForm_searching__ZvHu9 input {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/SearchForm/SearchForm.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,wCAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,WAAA;EACA,WAAA;AACF;AAEC;EACC,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,mCAAA;EACA,SAAA;EACA,WAAA;AAAF;AAGC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AADF;AAGE;EACC,UAAA;EACA,YAAA;EACA,WAAA;AADH;AAKC;EA9CD;IA+CE,WAAA;IACA,YAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,gBAAA;EAFA;EAIA;IACC,aAAA;EAFD;EAKA;IACC,aAAA;EAHD;EAMA;IAEC,wBAAA;IACA,mBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,WAAA;EALD;EAOC;IACC,cAAA;EALF;EAQC;IACC,aAAA;EANF;AACF;AAUC;EACC,gBAAA;EACA,kBAAA;AARF;AAWC;EACC,eAAA;EACA,kBAAA;AATF;AAWE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AATH;AAaG;EACC,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAXJ;AAaI;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AAXL;AAaK;EACC,gBAAA;EACA,WAAA;AAXN;AAeI;EACC,aAAA;EACA,WAAA;EACA,gBAAA;AAbL;AAgBI;EACC,4BAAA;EACA,6BAAA;AAdL;AAiBI;EACC,+BAAA;EACA,gCAAA;AAfL;AAkBI;EACC,aAAA;EACA,WAAA;EACA,gBAAA;AAhBL;AAmBI;EACC,aAAA;EACA,WAAA;EACA,gBAAA;AAjBL;AAsBE;EACC,oCAAA;AApBH;AAuBE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AArBH;AAyBC;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,+BAAA;AAvBF;AAyBE;EACC,sBAAA;AAvBH;;AA4BA;EACC,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAzBD;AA2BC;EACC,gBAAA;EACA,2CAAA;AAzBF;AA4BC;EAXD;IAYE,wBAAA;IACA,mBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,WAAA;EAzBA;EA2BA;IACC,aAAA;EAzBD;EA4BA;IACC,cAAA;EA1BD;AACF","sourcesContent":[".search-form {\n\tposition: absolute;\n\tright: 15px;\n\ttop: 15px;\n\twidth: calc(100% - 30px);\n\tz-index: 150000;\n\tmax-width: 250px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\ttransition: all 0.3s ease;\n\tmax-height: calc(100vh - 80px);\n\tmax-height: calc(100 * var(--vh) - 80px);\n\tbox-shadow: var(--shadow);\n\tborder-radius: 22px;\n\tbackground-color: white;\n\n\t> * {\n\t\tmargin: 2px;\n\t\twidth: 100%;\n\t}\n\n\tinput {\n\t\tpadding: 10px 22px;\n\t\tfont-size: 16px;\n\t\tborder-radius: 22px;\n\t\tborder: none;\n\t\ttransition: border-radius 0.3s ease;\n\t\tmargin: 0;\n\t\twidth: 100%;\n\t}\n\n\t.search-icon {\n\t\tdisplay: none;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 18px;\n\t\twidth: 18px;\n\n\t\tsvg {\n\t\t\tfill: #222;\n\t\t\theight: 18px;\n\t\t\twidth: 18px;\n\t\t}\n\t}\n\n\t@media screen and (max-width: 600px) {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tborder-radius: 25px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tright: 23px;\n\t\tmax-width: 500px;\n\n\t\t.search-icon {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\tinput {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&:hover,\n\t\t&:active {\n\t\t\twidth: calc(100% - 30px);\n\t\t\tborder-radius: 22px;\n\t\t\theight: fit-content;\n\t\t\tright: 15px;\n\n\t\t\tinput {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t.search-icon {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t.custom-select {\n\t\tfont-weight: 500;\n\t\tpadding: 10px 20px;\n\t}\n\n\t.search-results {\n\t\tpadding: 10px 0;\n\t\toverflow-y: scroll;\n\n\t\t.no-results-found {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 10px;\n\t\t\tcolor: grey;\n\t\t}\n\n\t\t.result {\n\t\t\ta {\n\t\t\t\tpadding: 5px 20px;\n\t\t\t\tdisplay: block;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: rgb(50, 50, 50);\n\t\t\t\tfont-weight: 500;\n\n\t\t\t\t.main {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: baseline;\n\n\t\t\t\t\t.distance {\n\t\t\t\t\t\tfont-size: small;\n\t\t\t\t\t\tcolor: grey;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.sub {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tcolor: grey;\n\t\t\t\t\tfont-size: small;\n\t\t\t\t}\n\n\t\t\t\t&:first-child {\n\t\t\t\t\tborder-top-left-radius: 22px;\n\t\t\t\t\tborder-top-right-radius: 22px;\n\t\t\t\t}\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tborder-bottom-left-radius: 22px;\n\t\t\t\t\tborder-bottom-right-radius: 22px;\n\t\t\t\t}\n\n\t\t\t\t.skills {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tcolor: grey;\n\t\t\t\t\tfont-size: small;\n\t\t\t\t}\n\n\t\t\t\t.objects {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tcolor: grey;\n\t\t\t\t\tfont-size: small;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.result:hover {\n\t\t\tbackground-color: rgb(216, 255, 205);\n\t\t}\n\n\t\t.loading-spinner {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 20px;\n\t\t}\n\t}\n\n\t.close-or-open-results-list {\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tborder-bottom-right-radius: 15px;\n\t\tborder-bottom-left-radius: 15px;\n\n\t\t&:hover {\n\t\t\tbackground-color: #eee;\n\t\t}\n\t}\n}\n\n.search-form.searching {\n\tpadding: 10px 20px 2px 20px;\n\tbackground-color: white;\n\tborder-radius: 30px;\n\tmax-width: 500px;\n\n\tinput {\n\t\tborder-radius: 0;\n\t\tborder-bottom: 1px solid rgb(200, 200, 200);\n\t}\n\n\t@media screen and (max-width: 600px) {\n\t\twidth: calc(100% - 30px);\n\t\tborder-radius: 22px;\n\t\theight: fit-content;\n\t\tright: 15px;\n\n\t\t.search-icon {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\tinput {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-form": `SearchForm_search-form__7J1Fv`,
	"search-icon": `SearchForm_search-icon__aSlWY`,
	"custom-select": `SearchForm_custom-select__VUgY9`,
	"search-results": `SearchForm_search-results__68gYz`,
	"no-results-found": `SearchForm_no-results-found__zTQMb`,
	"result": `SearchForm_result__qX+oA`,
	"main": `SearchForm_main__2BFub`,
	"distance": `SearchForm_distance__eC9mC`,
	"sub": `SearchForm_sub__z5FKm`,
	"skills": `SearchForm_skills__CBysm`,
	"objects": `SearchForm_objects__TTKar`,
	"loading-spinner": `SearchForm_loading-spinner__Src91`,
	"close-or-open-results-list": `SearchForm_close-or-open-results-list__cdhvm`,
	"searching": `SearchForm_searching__ZvHu9`
};
export default ___CSS_LOADER_EXPORT___;
